// import { showQrCodePopup } from "actions/dashboard/dashboard";
// import { store } from "reducers/store";
import properties from "properties";

export const ENVIRONMENT = properties.ENV;

export const ORDERED_PRODUCTS_DEFAULT_BEGINING_DATE = "2015-01-01";

export const DRAWER_LINKS = [
    {
        key: "dashboard",
        icon: "icon-dashboard",
        display: "title.dashboard",
        target: "/web/dashboard"
    },
    {
        key: "my-upcomings",
        icon: "icon-myAppointments",
        display: "title.my_upcomings",
        target: "/web/my-upcomings"
    },
    {
        key: "my-orders",
        icon: "icon-myOrders",
        display: "title.my_orders",
        target: "/web/my-orders"
    },
    {
        key: "my-health-profile",
        icon: "icon-myHealthProfile",
        display: "title.my_health_profile",
        target: "/web/my-health-profile?tab=biomarkers"
    },
    // {
    //     key: "chat",
    //     icon: "icon-chat",
    //     display: "title.chat",
    //     target: "/web/chat"
    // },
    // {
    //   key: "my-reviews",
    //   icon: "icon-myReviews",
    //   display: "title.my_reviews",
    //   target: "/dashboard",
    // },
    // {
    //   key: "my-wishlist",
    //   icon: "icon-myWishlist",
    //   display: "title.my_wishlist",
    //   target: "/dashboard",
    // },
    {
        key: "my-account",
        icon: "icon-myAccount",
        display: "title.my_account",
        target: "/web/my-account"
    },
    {
        key: "family-and-friends",
        icon: "icon-familyAndFriends",
        display: "title.family_members",
        target: "/web/family-and-friends"
    }
    // {
    //     key: "my-qr-code",
    //     icon: "icon-myQRCode",
    //     display: "title.my_qr-code",
    //     onClick: () => store.dispatch(showQrCodePopup())
    //     // target: "/web/qr-code",
    // }
    // {
    //   key: "Settings",
    //   icon: "icon-settings",
    //   display: "Settings",
    //   target: "/dashboard",
    // },
    // {
    //     key: "activate-test",
    //     icon: "icon-last-item",
    //     display: "Activate Test",
    //     target: "/web/home-testing/manually"
    // }
];

export const WHITELISTED_PURCHASING_LAYOUT_ROUTES = [
    "/web/cart",
    "/web/book-appointment",
    "/web/product/details",
    "/web/products",
    "/web/productsinline",
    "/web/shipping-informations",
    "/web/checkout",
    "/web/booked-screen",
    "/web/traveler-screen",
    "/web/paypal",
    "/web/locations"
];

export const WHITELISTED_ROUTES_FOR_SIDEBAR = [
    "/web/dashboard",
    "/web/my-health-profile",
    "/web/my-health-profile/test",
    "/web/my-health-profile/biomarker",
    "/web/my-health-profile/consultations",
    "/web/my-orders",
    "/web/my-upcomings",
    "/web/my-account",
    "/web/family-and-friends",
    "/web/my-orders/view-order",
    "/web/appointments-history",
    "/web/chat",
    "/web/upload-documents"
];

export const PAGINATE_PER_PAGE = 10;

export const PAGINATE_PAGE_SIZES = [10, 50];

export const CONSULTATION_INSTRUCTIONS = [
    {
        number: "01",
        text: "consultation.instructions_1"
    },
    {
        number: "02",
        text: "consultation.instructions_2"
    },
    {
        number: "03",
        text: "consultation.instructions_3"
    },
    {
        number: "04",
        text: "consultation.instructions_4"
    },
    {
        number: "05",
        text: "consultation.instructions_5"
    },
    {
        number: "06",
        text: "consultation.instructions_6"
    },
    {
        number: "07",
        text: "consultation.instructions_7"
    },
    {
        number: "08",
        text: "consultation.instructions_8"
    },
    {
        number: "09",
        text: "consultation.instructions_9"
    }
];

export const SAMPLE_TAKING_INSTRUCTIONS = [
    {
        number: "1",
        name: "sample_taking.instructions_1"
    },
    {
        number: "2",
        name: "sample_taking.instructions_2"
    },
    {
        number: "3",
        name: "sample_taking.instructions_3"
    },
    {
        number: "4",
        name: "sample_taking.instructions_4"
    },
    {
        number: "5",
        name: "sample_taking.instructions_5"
    },
    {
        number: "6",
        name: "sample_taking.instructions_6"
    },
    {
        number: "7",
        name: "sample_taking.instructions_7"
    },
    {
        number: "8",
        name: "sample_taking.instructions_8"
    },
    {
        number: "9",
        name: "sample_taking.instructions_9"
    },
    {
        number: "10",
        name: "sample_taking.instructions_10"
    }
];

export const MAX_FILE_SIZE = 2000000; //2MB

export const WHITELISTED_FILE_TYPES = ["application/pdf", "image/jpeg", "image/png", "image/jpg", "audio/mp3", "audio/mpeg"];

export const ALL_PRODUCTS_FILTER = [
    { text: "All", language: "en" },
    { text: "Alle", language: "de" },
    { text: "Tous", language: "fr" },
    { text: "Todos", language: "es" }
];

export const HOME_PRODUCTS = ["C", "H", "A"];
export const ON_SITE_PRODUCTS = ["A", "G", "P", "V", "D", "F", "R"];
export const DOCTOR_LETTER_IDS = [1, 28]

export const GLUCOSE_RANGE_RAPORT_CONFIG = {
    rangeBarColors: "linear-gradient(to right, #FFA800 0%, #FFA800 24%, #ffff 24.20%, #ffff 25%, #46D278 25%, #46D278 49%, #ffff 49.20%, #ffff 50%, #F76D00 50%, #F76D00 74%, #ffff 74.20%, #ffff 75%, #FF0300 75%, #FF0300 100%)",
    width: "23.5%",
    barPosition: {
        Low: '0.5%',
        Normal: '25.5%',
        'Pre-diabetic': '50.5%',
        Diabetic: '75.5%',
    }
};

export const BLOOD_PREASSURE_RANGE_RAPORT_CONFIG = {
    rangeBarColors: "linear-gradient(to right, #6EC5CF 0%, #6EC5CF 14%, #ffff 14%, #ffff 14.20%, #1B9A48 14.20%, #46D278 28%, #ffff 28%, #ffff 28.20%, #46D278 28.20%, #46D278 42%, #ffff 42%, #ffff 42.20%, #A9D126 42.20%, #A9D126 58%, #ffff 58%, #ffff 58.20%, #FFA800 58.20%, #FFA800 72%, #ffff 72%, #ffff 72.20%, #F76D00 72.20%, #F76D00 86%, #ffff 86%, #ffff 86.20%, #F50000 86.20%, #F50000 100%)",
    width: "14%",
    barPosition: {
        Low: '0%',
        Optimal: '14.2%',
        Normal: '28.2%',
        'High Normal': '43.2%',
        'Grade 1': '58.5%',
        'Grade 2': '72%',
        'Grade 3': '86%',
    }
};

export const PULSE_RANGE_RAPORT_CONFIG = {
    rangeBarColors: "linear-gradient(to right, #FFA800 0%, #FFA800 33%, #ffff 33%, #ffff 33.3%, #46D278 33.3%, #46D278 66.3%, #ffff 66.3%, #ffff 66.6%, #FFA800 66.6%, #FFA800 99.6%, #ffff 99.6%, #ffff 99.9%)",
    width: "33.3%",
    barPosition: {
        Low: '0%',
        Normal: '33.3%',
        High: '66.3%',
    }
}

export const TEMPERATURE_RANGE_RAPORT_CONFIG = {
    rangeBarColors: "linear-gradient(to right, #FFA800 0%, #FFA800 33%, #ffff 33%, #ffff 33.3%, #46D278 33.3%, #46D278 66.3%, #ffff 66.3%, #ffff 66.6%, #FFA800 66.6%, #FFA800 99.6%, #ffff 99.6%, #ffff 99.9%)",
    width: "33.3%",
    barPosition: {
        Low: '0%',
        Normal: '33.3%',
        High: '66.3%',
    }
}

export const OXYGEN_SATURATION_RANGE_RAPORT_CONFIG = {
    rangeBarColors: "linear-gradient(to right, #F76D00 0%, #F76D00 33%, #ffff 33%, #ffff 33.3%, #FFA800 33.3%, #FFA800 66.3%, #ffff 66.3%, #ffff 66.6%, #46D278 66.6%, #46D278 99.6%, #ffff 99.6%, #ffff 99.9%)",
    width: "33.3%",
    barPosition: {
        Critical: '0%',
        Normal: '33.3%',
        High: '66.3%',
    }
}

export const GLUCOSE_UOM_IDS = {
    1: 'mg/dL',
    7: 'mmol/L'
}

export const BODY_COMPOSITION_RANGE_RAPORT_CONFIG = {
    rangeBarColors:
        'linear-gradient(to right, #6EC5CF 0%, #6EC5CF 24%, #ffff 24.20%, #ffff 25%, #46D278 25%, #46D278 49%, #ffff 49.20%, #ffff 50%, #FFA800 50%, #FFA800 74%, #ffff 74.20%, #ffff 75%, #F50000 75%, #F50000 100%)',
    width: '25%',
    barPosition: {
        Low: '0.5%',
        Normal: '25.5%  ',
        High: '50.5%',
        'Very High': '75.5%',
        'Obesity': '75.5%',
    },
};

export const BODY_WEIGHT_RANGE_RAPORT_CONFIG = {
    rangeBarColors:
        'linear-gradient(to right, #6EC5CF 0%, #6EC5CF 24%, #ffff 24.20%, #ffff 25%, #46D278 25%, #46D278 49%, #ffff 49.20%, #ffff 50%, #FFA800 50%, #FFA800 74%, #ffff 74.20%, #ffff 75%, #F50000 75%, #F50000 100%)',
    width: '25%',
    barPosition: {
        Underweight: '0.5%',
        'Normal weight': '25.5%',
        Overweight: '50.5%',
        'Obesity': '75.5%',
    },
};